import { ref } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'


export default function useGroupEdit(root) {

  const requestStatus = ref(false)

  const errors = ref({})

  const groupData = ref(null)

  const submit = () => {

    requestStatus.value = true
    errors.value = {}

    store.dispatch('app-group/editGroup', groupData.value).then(res => {
      requestStatus.value = false
      toaster('Group Updated successfully',
        'success', 'Success')

    }).catch(res => {
      errors.value = res.response.data
    }).finally(() => {
      requestStatus.value = false
    })
  }



  const fetchGroup = () => {
    requestStatus.value = true
    store.dispatch('app-group/fetchGroup', { id: router.currentRoute.params.id })
      .then(response => {
        groupData.value = response.data.data
        requestStatus.value = false
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 404) {
          groupData.value = undefined
          requestStatus.value = false
        }
      })
  }


  const toaster = (msg, variant = 'success', title = 'success') => {
    root.$root.$bvToast.toast(root.$i18n.t(msg), {
      title: root.$i18n.t(title),
      variant,
      solid: true,
    })
  }


  return {
    toaster,
    submit,
    groupData,
    fetchGroup,
    requestStatus,
    errors
  }

}
